import { createAction } from 'redux-act';
export const loadingEnd = createAction('On app loading end');
